import { hasCapability, type User } from "../base";

export const region = {
  update: (user: User) => hasCapability(user, "region.update"),
  create: (user: User) => hasCapability(user, "region.create"),
  delete: (user: User) => hasCapability(user, "region.delete"),
  viewSettings: (user: User) => hasCapability(user, "region.viewSettings"),
  read: (_user: User) => true,
  viewAssignablePersons: (user: User) => hasCapability(user, "region.viewAssignablePersons"),
};
